/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
// all icons and other images
import IconExchange from "../../assets/images/icon-exchange.svg";
import { CustomAutoComplete } from "./CustomAutoComplete";
import FlightDatePicker from "./FlightDatePicker";
import moment from "../../../node_modules/moment/moment";
import { Col, Row } from "react-bootstrap";
import FormLabel from "react-bootstrap/FormLabel";
import TravellersAndClassSection from "./TravellersAndClassSection";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import {
  ECONOMY_TRAVEL_CLASS,
  EVISA_INQ_TYPE,
  FLIGHT_HOTEL_INQ_TYPE,
  FLIGHT_INQ_TYPE,
  MULTI_CITY_TRIP,
  ONE_WAY_TRIP,
  ROUND_TRIP,
} from "constants/common";
import { ValidateFlightSearch } from "./ValidateFlightUser";
import { createEVisaInquiry, createInquiry } from "services/flights";
import { errorToast, getErrorObject, successToast } from "utilities/utils";
import { appRoutesConst } from "app/navigation";
import { useNavigate } from "react-router-dom";
import RoomDetailsForm from "./RoomDetailsForm";
import EvisaForm from "./EvisaForm";
import MultiCityFlightSearch from "./MultiCityFlightSearch";
import { Checkbox, Popover } from "antd";
import { useDispatch } from "react-redux";
import { addDays } from "date-fns";
import { getPaymentLink } from "services/Payments";
import PopOverComponent from "components/common/PopoverComponent";
import useOutsideAlerter from "hooks/useOutsideAlerter";
import TermsAndAckowledgeCheckbox from "components/common/TermsAndAckowledgeCheckbox";

// import PhoneInput from "components/common/PhoneInput";
// import { MuiTelInput } from 'mui-tel-input'

const initialState = {
  showFromDropDown: null,
  showToDropDown: null,
  sourceStation: null,
  destination: null,
  departure_date: new Date(),
  arrival_date: addDays(new Date(), 10),
  adultCount: 0,
  childCount: 0,
  infantCount: 0,
  travelClass: null,
  tripType: ROUND_TRIP,
  airports: [],
  travellersAndClass: {
    travelClass: ECONOMY_TRAVEL_CLASS,
    noOfTravellerType: [
      {
        type: "adult",
        members: 1,
      },
      {
        type: "children",
        members: 0,
      },
      {
        type: "infant",
        members: 0,
      },
    ],
  },
  full_name: "",
  email: "",
  phone: "",
  no_of_rooms: "",
  room_ratings: "",
  no_of_evisa: "",
  nationalities: [],
  passport_type: "",
  no_of_passports: "",
  errors: null,
  multiCities: [],
  isDateFlexible: false,
  isDateFixed: false,
  isCountryEditable: true,
  other_passport_type: "",
  other_passports: [],
  passports: [],
  open: false,
  fromOnway: false,
  isTermsAccepted: false,
};
export default function FlightSearch({ mainType }) {
  // states
  const [state, setState] = useState(initialState);
  const [tripType, setTripType] = useState(ROUND_TRIP);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, () => {
    // console.log("outside callback");
    setState({ ...state, open: false });
  });

  const wrapperRe2 = useRef(null);
  useOutsideAlerter(wrapperRe2, () => {
    // console.log("outside callback");
    setState({ ...state, open2: false });
  });
  // const [singleDate, setSingleDate] = React.useState(null);
  // const [rangeDate, setRangeDate] = React.useState([
  //   new Date(),
  //   moment().add("day", 1),
  // ])
  const phoneRef = useRef(null);

  useEffect(() => {
    setState({ ...state, tripType: ONE_WAY_TRIP });
  }, [mainType]);

  const handleShowHideAutocomplete = (type) => {
    if (type === "from") {
      setState({
        ...state,
        showFromDropDown: true,
        // showToDropDown: false,
        // destination: null,
      });
    }

    if (type === "to") {
      setState({
        ...state,
        // showFromDropDown: false,
        // sourceStation: null,
        showToDropDown: true,
      });
    }
  };

  const getFromToValue = (value, type) => {
    if (type === "from") {
      console.log(" from getFromToValue", value);

      setState({
        ...state,
        sourceStation: value,
        showFromDropDown: false,
        errors: {
          ...state.errors,
          sourceStation: null,
        },
      });
    } else {
      console.log(" tos getFromToValue", value);

      setState({
        ...state,
        destination: value,
        showToDropDown: false,
        errors: {
          ...state.errors,
          destination: null,
        },
      });
    }
  };

  // date changes
  const handleDateChange = (dt, type) => {
    console.log("date", dt);

    if (tripType === ONE_WAY_TRIP || tripType === MULTI_CITY_TRIP) {
      setState({ ...state, departure_date: dt });
    }
    if (tripType === ROUND_TRIP) {
      setState({
        ...state,
        departure_date: dt[0],
        arrival_date: dt[1],
      });
    }
  };

  useEffect(() => {
    if (
      (tripType === ONE_WAY_TRIP || tripType === MULTI_CITY_TRIP) &&
      state.departure_date
    ) {
      setState({ ...state, open: false });
    }

    if (tripType === ROUND_TRIP && state.departure_date && state.arrival_date) {
      setState({ ...state, open: state?.fromOneWay ? true : false });
    }
  }, [state.departure_date, state.arrival_date]);

  // handle multiple select

  const handleMultipleChange = (values) => {
    setState({
      ...state,
      nationalities: values,
      errors: {
        ...state.errors,
        nationalities: null,
      },
    });
  };

  // handle trip type radio
  const handleTripTypeChange = (value, fromOneWay) => {
    if (fromOneWay) {
      setState({ ...state, fromOneWay: true });
    }
    setTripType(value);
  };

  useEffect(() => {
    if (tripType === ROUND_TRIP) {
      setState({
        ...state,
        departure_date: state.departure_date
          ? state.departure_date
          : new Date(),
        arrival_date: state.arrival_date
          ? state.arrival_date
          : addDays(new Date(), 10),
        // open: state.departure_date ? false : true,
      });
    }
  }, [tripType]);

  const handleExchange = () => {
    setState({
      ...state,
      sourceStation: state.destination,
      destination: state.sourceStation,
    });
  };

  const getAllTravllersAndClass = (data) => {
    setState({ ...state, travellersAndClass: data });
  };

  const getAllRoomTypes = (data) => {
    setState({
      ...state,
      no_of_rooms: data,
      errors: {
        ...state.errors,
        no_of_rooms: "",
      },
    });
  };

  const handleChange = (e, isRoomDropdown) => {
    console.log("eeeeeeee", e);
    if (isRoomDropdown) {
      setState({
        ...state,
        [`no_of_rooms`]: e,
        errors: {
          ...state.errors,
          [`no_of_rooms`]: null,
        },
      });
    } else {
      setState({
        ...state,
        [e.target.name]: e.target.value,
        errors: {
          ...state.errors,
          [e.target.name]: null,
        },
      });
    }
  };

  const handlePhoneChange = (e) => {
    // let value = e.target.value
    //   .replaceAll("(", "")
    //   .replaceAll(")", "")
    //   .replaceAll(" ", "")
    //   .replaceAll("_", "")
    //   .replaceAll("-", "");
    console.log("value", e);
    setState({
      ...state,
      phone: `${e}`,
      errors: {
        ...state.errors,
        phone: null,
      },
    });
  };

  const handleCheckbox = (e, name) => {
    if (name === "isDateFixed") {
      setState({
        ...state,
        isDateFixed: e.target.checked,
        isDateFlexible: !e.target.checked,
        errors: {
          date_fix_flexi: null,
        },
      });
    }
    if (name === "isDateFlexible") {
      setState({
        ...state,
        isDateFixed: !e.target.checked,
        isDateFlexible: e.target.checked,
        errors: {
          date_fix_flexi: null,
        },
      });
    }
  };
  // useEffect(() => {
  //   setState({
  //     ...state,
  //     isDateFlexible: !state.isDateFixed,
  //     isDateFixed: !state.isDateFlexible,
  //   });
  // }, [state.isDateFixed, state.isDateFlexible]);

  const getFinalMultiCityArray = (multiCities) => {
    console.log("multiCities", multiCities);
    setState({
      ...state,
      multiCities: multiCities,
    });
  };

  const getOtherPassports = (otherPassports) => {
    setState({ ...state, other_passports: otherPassports });
  };

  const getUSCanadaPassports = (passports) => {
    setState({ ...state, passports: passports });
  };

  const handleCreditCard = async (evisaData) => {
    try {
      let payload = {
        type: "e_visa",
        usa_canada: evisaData.passportLength,
        no_of_non_usa: evisaData.otherNationalityPassportLength,
      };
      let paymentLinkResponse = await getPaymentLink(payload);
      let paymentLink = paymentLinkResponse?.data?.data?.url;
      console.log("paymentLinkResponse", paymentLinkResponse.data.data.url);
      window.open(paymentLink, "_blank");
      // window.location.reload();
    } catch (e) {
      const { message } = getErrorObject(e);
      errorToast({
        content: message,
      });
    }
  };

  const clearEvisaForm = () => {
    setState({
      ...state,
      no_of_evisa: "",
      nationalities: "",
      no_of_passports: null,
      passports: [],
      other_passports: [],
      passport_type: "",
      other_passport_type: "",
      full_name: "",
      email: "",
      phone: "1",
      isTermsAccepted: false,
    });
  };

  const submitFlightSearch = async (next) => {
    console.log("EVISA_INQ_TYPE", mainType);
    // next();

    let data = {
      full_name: state.full_name,
      email: state.email,
      phone: state.phone,
      mainType: mainType,
      no_of_rooms: state.no_of_rooms,
      room_ratings: state.room_ratings,
      no_of_evisa: state.no_of_evisa,
      nationalities: state.nationalities,
      passport_type: state.passport_type,
      no_of_passports: state.no_of_passports,
      other_passport_type: state.other_passport_type,
      passports: state.passports,
      other_passports: state.other_passports,
      isDateFixed: state.isDateFixed,
      isDateFlexible: state.isDateFlexible,
      sourceStation: state.sourceStation,
      destination: state.destination,
      isTermsAccepted: state.isTermsAccepted,
    };
    console.log(
      "----------------------------------------------------------------",
      data
    );
    const errors = ValidateFlightSearch(data);
    if (!errors.isValid) {
      setState({ ...state, errors: errors.errors, submitting: false });
    } else {
      let roomTypesParams = {};
      let eVisaParams = {};
      let flightParams = {};
      let multiCitiesParams = {};

      if (state.multiCities.length > 0) {
        multiCitiesParams = {
          multiCity: state.multiCities,
        };
      }

      if (mainType === FLIGHT_HOTEL_INQ_TYPE) {
        roomTypesParams = {
          roomType: data.no_of_rooms,
          roomRating: data.room_ratings,
        };
      }

      if (mainType === EVISA_INQ_TYPE) {
        eVisaParams = {
          passportLength: state.passport_type,
          otherNationalityPassportLength: state.other_passport_type,
        };
      }

      if (mainType === FLIGHT_INQ_TYPE || mainType === FLIGHT_HOTEL_INQ_TYPE) {
        flightParams = {
          tripType: tripType,
          from: state.sourceStation.split("/")[0],
          to: state.destination.split("/")[0],
          departureDate: moment(state.departure_date).format("YYYY/MM/DD"),
          returnDate: state.arrival_date
            ? moment(state.arrival_date).format("YYYY/MM/DD")
            : null,
          noOfTravellerType: state.travellersAndClass.noOfTravellerType,
          travelClass: state.travellersAndClass.travelClass,
          isDateFixed: state.isDateFixed,
          isDateFlexible: state.isDateFlexible,
        };
      }
      let payload = {
        type: mainType,
        fullName: state.full_name,
        email: state.email,
        mobileNumber: state.phone,

        ...flightParams,
        ...roomTypesParams,
        ...eVisaParams,
        ...multiCitiesParams,
      };

      console.log("Room Payload", payload);
      if (mainType === FLIGHT_INQ_TYPE || mainType === FLIGHT_HOTEL_INQ_TYPE) {
        try {
          await setState({ ...state, submitting: true });

          let inquiryResponse = await createInquiry(payload);
          if (inquiryResponse?.data?.success) {
            if (mainType === EVISA_INQ_TYPE) {
              successToast({
                content: "E-Visa Inquiry submitted successfully",
              });
              next();
            } else {
              let payloadRedux = {
                ...inquiryResponse.data.data,
                ...payload,
                code_from: state.sourceStation.split("/")[1],
                code_to: state.destination.split("/")[1],
              };
              dispatch({
                type: "ON_SET_TRIP_DETAILS",
                payload: payloadRedux,
              });
              console.log("MUL PAY", multiCitiesParams);
              navigate(appRoutesConst.searchflight);
            }
            await setState({ ...initialState });
          } else {
            console.log("----->>", inquiryResponse);
          }
        } catch (e) {
          let { message } = getErrorObject(e);
          console.log("eeeee", e);
          errorToast({
            content: message,
          });
          await setState({ ...state, submitting: false });
        }
      } else {
        setState({ ...state, submitting: true });
        console.log("payload", payload);
        console.log("passports", state.passports);
        console.log("other passports", state.other_passports);
        let formData = new FormData();
        formData.set("fullName", payload.fullName);
        formData.set("email", payload.email);
        formData.set("mobileNumber", payload.mobileNumber);
        formData.set("passportLength", payload.passportLength);
        formData.set(
          "otherNationalityPassportLength",
          payload.otherNationalityPassportLength
        );

        dispatch({
          type: "ON_SET_EVISA_DATA",
          payload: payload,
        });
        state.passports.map((d, index) => {
          formData.set(`us_ca_passport[${index}]`, d.passport_front_page);
          formData.set(`us_ca_photo[${index}]`, d.avatar_photo);
          return null;
        });

        state.other_passports.map((d, index) => {
          formData.set(`other_passport[${index}]`, d.passport_front_page);
          formData.set(`other_photo[${index}]`, d.avatar_photo);
          formData.set(`other_green_card[${index}]`, d.green_card);
          return null;
        });
        console.log("formdata", formData);
        try {
          let inquiryResponse = await createEVisaInquiry(formData);
          if (inquiryResponse.data.success) {
            successToast({
              content: "E-Visa Inquiry submitted successfully",
            });
            next();
            // } else {
            //   dispatch({
            //     type: "ON_SET_TRIP_DETAILS",
            //     payload: inquiryResponse.data.data,
            //   });
            //   navigate(appRoutesConst.searchflight);
            // }
            setState({ ...state, submitting: false });
          }
          await setState({ ...initialState });
        } catch (e) {
          let { message } = getErrorObject(e);
          errorToast({
            content: message,
          });
          await setState({ ...state, submitting: false });
        }
      }
    }
  };

  const submitEvisaSearch = async (next) => {
    console.log("EVISA_INQ_TYPE", mainType);
    // next();

    let data = {
      full_name: state.full_name,
      email: state.email,
      phone: state.phone,
      mainType: mainType,
      no_of_rooms: state.no_of_rooms,
      room_ratings: state.room_ratings,
      no_of_evisa: state.no_of_evisa,
      nationalities: state.nationalities,
      passport_type: state.passport_type,
      no_of_passports: state.no_of_passports,
      other_passport_type: state.other_passport_type,
      passports: state.passports,
      other_passports: state.other_passports,
      isDateFixed: state.isDateFixed,
      isDateFlexible: state.isDateFlexible,
      sourceStation: state.sourceStation,
      destination: state.destination,
      isTermsAccepted: state.isTermsAccepted,
    };
    const errors = ValidateFlightSearch(data);
    if (!errors.isValid) {
      setState({ ...state, errors: errors.errors, submitting: false });
    } else {
      let roomTypesParams = {};
      let eVisaParams = {};
      let flightParams = {};
      let multiCitiesParams = {};

      if (state.multiCities.length > 0) {
        multiCitiesParams = {
          multiCity: state.multiCities,
        };
      }

      // if (mainType === FLIGHT_HOTEL_INQ_TYPE) {
      //   roomTypesParams = {
      //     noOfRooms: data.no_of_rooms ? data.no_of_rooms.value : null,
      //     roomRating: data.room_ratings,
      //   };
      // }

      if (mainType === EVISA_INQ_TYPE) {
        eVisaParams = {
          passportLength: state.passport_type,
          otherNationalityPassportLength: state.other_passport_type,
        };
      }

      // if (mainType === FLIGHT_INQ_TYPE || mainType === FLIGHT_HOTEL_INQ_TYPE) {
      //   flightParams = {
      //     tripType: tripType,
      //     from: state.sourceStation.split("/")[0],
      //     to: state.destination.split("/")[0],
      //     departureDate: moment(state.departure_date).format("YYYY/MM/DD"),
      //     returnDate: state.arrival_date
      //       ? moment(state.arrival_date).format("YYYY/MM/DD")
      //       : null,
      //     noOfTravellerType: state.travellersAndClass.noOfTravellerType,
      //     travelClass: state.travellersAndClass.travelClass,
      //     isDateFixed: state.isDateFixed,
      //     isDateFlexible: state.isDateFlexible,
      //   };
      // }
      let payload = {
        type: mainType,
        fullName: state.full_name,
        email: state.email,
        mobileNumber: state.phone,

        ...flightParams,
        ...roomTypesParams,
        ...eVisaParams,
        ...multiCitiesParams,
      };

      setState({ ...state, submitting: true });
      console.log("payload", payload);
      console.log("passports", state.passports);
      console.log("other passports", state.other_passports);
      let formData = new FormData();
      formData.set("fullName", payload.fullName);
      formData.set("email", payload.email);
      formData.set("mobileNumber", payload.mobileNumber);
      formData.set("passportLength", payload.passportLength);
      formData.set(
        "otherNationalityPassportLength",
        payload.otherNationalityPassportLength
      );

      dispatch({
        type: "ON_SET_EVISA_DATA",
        payload: payload,
      });
      console.log("Passpoerts", state.passports);
      state.passports.map((d, index) => {
        formData.set(`us_ca_passport[${index}]`, d.passport_front_page);
        formData.set(`us_ca_photo[${index}]`, d.avatar_photo);
        return null;
      });

      state.other_passports.map((d, index) => {
        formData.set(`other_passport[${index}]`, d.passport_front_page);
        formData.set(`other_photo[${index}]`, d.avatar_photo);
        formData.set(`other_green_card[${index}]`, d.green_card);
        return null;
      });

      console.log("formData", formData);
      try {
        let inquiryResponse = await createEVisaInquiry(formData);
        if (inquiryResponse.data.success) {
          successToast({
            content: "E-Visa Inquiry submitted successfully",
          });
          next();
          // } else {
          //   dispatch({
          //     type: "ON_SET_TRIP_DETAILS",
          //     payload: inquiryResponse.data.data,
          //   });
          //   navigate(appRoutesConst.searchflight);
          // }
          setState({ ...state, submitting: false });
        }
        // await setState({ ...initialState });
      } catch (e) {
        let { message } = getErrorObject(e);
        errorToast({
          content: message,
        });
        await setState({ ...state, submitting: false });
      }
    }
  };
  console.log("state", state);

  return (
    <>
      {(mainType === "flight" || mainType === FLIGHT_HOTEL_INQ_TYPE) && (
        <div className="custom-radiolist">
          <div key={`inline-radio`} className="mb-3 ">
            <div class="mb-3 ">
              <div
                class={`custom-radio trip-radio-1 ${
                  tripType === ROUND_TRIP && "checked-active"
                }  form-check form-check-inline`}
              >
                <label
                  onClick={() => handleTripTypeChange(ROUND_TRIP)}
                  title=""
                  for="inline-radio-1"
                  class="form-check-label"
                >
                  ROUND TRIP
                </label>
              </div>
              <div
                class={`custom-radio trip-radio-1 ${
                  tripType === ONE_WAY_TRIP && "checked-active"
                }  form-check form-check-inline`}
              >
                <label
                  onClick={() => handleTripTypeChange(ONE_WAY_TRIP)}
                  title=""
                  for="inline-radio-2"
                  class="form-check-label"
                >
                  ONE WAY
                </label>
              </div>
              <div
                class={`custom-radio trip-radio-1 ${
                  tripType === MULTI_CITY_TRIP && "checked-active"
                }  form-check form-check-inline`}
              >
                <label
                  onClick={() => handleTripTypeChange(MULTI_CITY_TRIP)}
                  title=""
                  for="inline-radio-3"
                  class="form-check-label"
                >
                  MULTI CITY
                </label>
              </div>
            </div>
          </div>
          <div className="search-content-box">
            <div className="search-area-filter">
              <div class="main-search-left-section">
                <div
                  className={`search-left cursor-pointer ${
                    state.showFromDropDown && "active"
                  }`}
                >
                  <div className="search-left-content">
                    <span
                      // onClick={() => handleShowHideAutocomplete("from")}
                      className="text-uppercase clickable-span"
                    >
                      Depart from
                    </span>

                    {state.showFromDropDown === false && (
                      <div
                        onClick={(e) => {
                          handleShowHideAutocomplete("from");
                        }}
                      >
                        <h2 className="mb-0">
                          <strong>
                            {state.sourceStation &&
                              state.sourceStation.split("/")[0]}
                          </strong>
                        </h2>
                        <span className="location-text font-size-14">
                          {state.sourceStation &&
                            `${state.sourceStation.split("/")[1]}`}{" "}
                        </span>
                      </div>
                    )}

                    {tripType !== MULTI_CITY_TRIP && (
                      <span
                        role={"button"}
                        onClick={handleExchange}
                        className="img-exchange"
                      >
                        <img
                          src={IconExchange}
                          alt="Icon Exchange"
                          className="img-fluid"
                        />
                      </span>
                    )}
                    {(state.showFromDropDown === null ||
                      state.showFromDropDown === true) && (
                      <CustomAutoComplete
                        getFromToValue={getFromToValue}
                        type="from"
                        tripType={tripType}
                        airports={state.airports}
                      />
                    )}
                    {state.errors && (
                      <span className="text-danger">
                        {state?.errors?.sourceStation}
                      </span>
                    )}
                  </div>
                </div>
                <div
                  className={`search-left second-left-section cursor-pointer ${
                    state.showToDropDown && "active"
                  }`}
                >
                  <div className="search-left-content">
                    <span
                      // onClick={() => handleShowHideAutocomplete("to")}
                      className="text-uppercase clickable-span"
                    >
                      Arrive At
                    </span>
                    {state.showToDropDown === false && (
                      <div onClick={() => handleShowHideAutocomplete("to")}>
                        <h2 className="mb-0">
                          <strong>
                            {state.destination &&
                              state.destination.split("/")[0]}
                          </strong>
                        </h2>
                        <span className="location-text font-size-14">
                          {state.destination &&
                            `${state.destination.split("/")[1]}`}{" "}
                          {/* {state.destination && state.destination.split("/")[0]} */}
                        </span>
                      </div>
                    )}

                    {(state.showToDropDown === null ||
                      state.showToDropDown === true) && (
                      <CustomAutoComplete
                        getFromToValue={getFromToValue}
                        type="to"
                        tripType={tripType}
                      />
                    )}
                    {state.errors && (
                      <span className="text-danger">
                        {state?.errors?.destination}
                      </span>
                    )}
                  </div>
                  {state.sourceStation !== null &&
                    state.destination !== null &&
                    state.sourceStation === state.destination && (
                      <div class="errorSection makeFlex" id="errorMessage">
                        <span class="landingSprite errorIcon appendRight10"></span>
                        <span
                          data-cy="sameCityError"
                          class="redText errorMsgText"
                        >
                          Source &amp; Destination airports cannot be the same,
                          please select diffrent airport
                        </span>
                      </div>
                    )}
                </div>
              </div>
              <div class="main-search-right-section">
                <Popover
                  trigger="click"
                  placement="bottom"
                  open={state.open}
                  content={
                    <div ref={wrapperRef}>
                      <FlightDatePicker
                        handleDateChange={(dt) => {
                          handleDateChange(dt, "departure_date");
                        }}
                        tripType={tripType}
                        startDate={state.departure_date}
                        endDate={state.arrival_date}
                      />
                    </div>
                  }
                >
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      setState({ ...state, open: true });
                    }}
                    className="search-left p-0 cursor-pointer"
                  >
                    <div
                      className={`search-left-content deprature-return-section cursor-pointer`}
                    >
                      <div
                        className={`deprature-section deprature-return-content ${
                          tripType === MULTI_CITY_TRIP && "border-none"
                        }`}
                      >
                        <div className="deprature-title d-flex text-uppercase">
                          Deprature
                          <span >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="11"
                              height="6"
                              viewBox="0 0 11 6"
                              fill="none"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M1.12508 0.528512C1.38562 0.268165 1.80802 0.268165 2.06855 0.528512L5.59959 4.05712L9.13064 0.528512C9.39116 0.268165 9.81358 0.268165 10.0741 0.528512C10.3346 0.788865 10.3346 1.21097 10.0741 1.47133L6.07132 5.47132C5.81081 5.73165 5.38838 5.73165 5.12787 5.47132L1.12508 1.47133C0.864556 1.21097 0.864556 0.788865 1.12508 0.528512Z"
                                fill="#118DFF"
                              />
                            </svg>
                          </span>
                        </div>
                        <h3 className="deprature-date font-weight-bold d-flex align-items-end mb-0">
                          {moment(state.departure_date).format("DD")}
                          <h6 className="font-weight-bold mb-1 ml-2">
                            {moment(state.departure_date).format("MMM'YY")}
                          </h6>
                        </h3>
                        <span className="font-size-14 font-weight-semibold ">
                          {moment(state.departure_date).format("dddd")}
                        </span>
                      </div>
                      {tripType !== MULTI_CITY_TRIP && (
                        <div className="return-section depraturen-return-content">
                          <div className="deprature-return-content border-none">
                            <div className="deprature-title d-flex  text-uppercase">
                              Return
                              <span className="ml-3">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="11"
                                  height="6"
                                  viewBox="0 0 11 6"
                                  fill="none"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M1.12508 0.528512C1.38562 0.268165 1.80802 0.268165 2.06855 0.528512L5.59959 4.05712L9.13064 0.528512C9.39116 0.268165 9.81358 0.268165 10.0741 0.528512C10.3346 0.788865 10.3346 1.21097 10.0741 1.47133L6.07132 5.47132C5.81081 5.73165 5.38838 5.73165 5.12787 5.47132L1.12508 1.47133C0.864556 1.21097 0.864556 0.788865 1.12508 0.528512Z"
                                    fill="#118DFF"
                                  />
                                </svg>
                              </span>
                            </div>
                            {tripType === ONE_WAY_TRIP && (
                              <span
                                role="presentation"
                                onClick={() =>
                                  handleTripTypeChange(ROUND_TRIP, true)
                                }
                                className="font-size-14 font-weight-semibold cursor-pointer"
                              >
                                <p>Tap to add return date</p>
                              </span>
                            )}
                            {tripType === ROUND_TRIP && (
                              <Fragment>
                                <h3 className="deprature-date font-weight-bold d-flex align-items-end mb-0">
                                  {moment(state.arrival_date).format("DD")}{" "}
                                  <h6 className="font-weight-bold mb-1 ml-2">
                                    {" "}
                                    {moment(state.arrival_date).format(
                                      "MMM'YY"
                                    )}
                                  </h6>
                                </h3>
                                <span className="font-size-14 font-weight-semibold ">
                                  {moment(state.arrival_date).format("dddd")}
                                </span>
                              </Fragment>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </Popover>

                <div
                  // style={{ display: state?.open2 ? "none" : "block" }}
                  className="search-right"
                >
                  <TravellersAndClassSection
                    getAllTravllersAndClass={getAllTravllersAndClass}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <br />
      {tripType === MULTI_CITY_TRIP && (
        <MultiCityFlightSearch
          departureDate={state.departure_date}
          getFinalMultiCityArray={getFinalMultiCityArray}
          sourceStation={state.destination}
          destination={state.destination}
        />
      )}
      {mainType !== EVISA_INQ_TYPE && (
        <div className="dates-checkbox-container">
          <Checkbox
            onChange={(e) => handleCheckbox(e, "isDateFlexible")}
            className="date-checkbox"
            checked={state.isDateFlexible}
          >
            {" "}
            Flexible +/- 2 Dates
          </Checkbox>
          <Checkbox
            onChange={(e) => handleCheckbox(e, "isDateFixed")}
            className="date-checkbox ml-4"
            checked={state.isDateFixed}
          >
            {" "}
            Fixed Dates
          </Checkbox>
          <br></br>
          {state.errors && (
            <span className="text-danger">{state.errors.date_fix_flexi}</span>
          )}
        </div>
      )}
      {mainType === FLIGHT_HOTEL_INQ_TYPE && (
        <RoomDetailsForm
          handleChange={handleChange}
          no_of_rooms={state.no_of_rooms}
          room_ratings={state.room_ratings}
          errors={state.errors}
          getAllRoomTypes={getAllRoomTypes}
        />
      )}
      {mainType === EVISA_INQ_TYPE && (
        <div className="display-reverse">
          {
            <EvisaForm
              handleChange={handleChange}
              handleMultipleChange={handleMultipleChange}
              getOtherPassports={getOtherPassports}
              getUSCanadaPassports={getUSCanadaPassports}
              handleEvisaSubmit={submitEvisaSearch}
              handleCreditCard={handleCreditCard}
              handleCheckbox={(e) => {
                setState({
                  ...state,
                  isTermsAccepted: e.target.checked,
                  errors: { ...state.errors, isTermsAccepted: null },
                });
              }}
              clearEvisaForm={clearEvisaForm}
              userDetailsForm={() => {
                return (
                  <div className="user-details-custom">
                    {/* <div className="user-details-title position-relative">
                    <p className="position-relative font-weight-semibold user-border mb-0">
                      User’s Details
                    </p>
                  </div> */}
                    <div>
                      <div className="user-detail-search-form">
                        <Row className="g-3">
                          <Col md>
                            <FormLabel controlId="floatingInputGrid">
                              <Form.Control
                                name="full_name"
                                onChange={handleChange}
                                value={state.full_name}
                                type="text"
                                placeholder="Enter Full Name"
                              />
                            </FormLabel>
                            {state.errors && (
                              <span className="text-danger">
                                {state.errors.full_name}
                              </span>
                            )}
                          </Col>
                          <Col md>
                            <FormLabel
                              controlId="floatingInputGrid"
                              // label="Email address"
                            >
                              <Form.Control
                                type="text"
                                name="email"
                                onChange={handleChange}
                                value={state.email}
                                placeholder="Enter Email Address"
                              />
                            </FormLabel>
                            {state.errors && (
                              <span className="text-danger">
                                {state.errors.email}
                              </span>
                            )}
                          </Col>
                          <Col md>
                            {(state.phone === "" || state.phone === "1") && (
                              <label
                                onClick={() => {
                                  console.log(
                                    "phoneref",
                                    phoneRef.current.numberInputRef.focus()
                                  );
                                }}
                                className="phone-lable"
                              >
                                (324) 242-3423
                              </label>
                            )}
                            <PhoneInput
                              country={"us"}
                              // onlyCountries={["us"]}
                              preferredCountries={["us"]}
                              inputClass="form-contorl"
                              countryCodeEditable={state.isCountryEditable}
                              onChange={(d) => handlePhoneChange(d)}
                              placeholder="+1 (324) 242-3423"
                              onFocus={() =>
                                setState({ ...state, isCountryEditable: false })
                              }
                              value={state.phone}
                              ref={phoneRef}
                            />
                            {state.errors && (
                              <span className="text-danger">
                                {state.errors.phone}
                              </span>
                            )}
                          </Col>
                        </Row>
                      </div>
                      <div className="search-button position-relative text-center">
                        {mainType !== EVISA_INQ_TYPE && (
                          <button
                            // onClick={() =>
                            //   // navigate(appRoutesConst.searchflight)
                            // }
                            onClick={submitFlightSearch}
                            className="btn btn-primary"
                          >
                            {state.submitting ? (
                              <span>
                                <span>Searching Flights ...</span>{" "}
                              </span>
                            ) : (
                              "Search"
                            )}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                );
              }}
              {...state}
            />
          }
        </div>
      )}
      {mainType !== EVISA_INQ_TYPE && (
        <div className="user-details">
          <div className="user-details-title position-relative">
            <p className="position-relative font-weight-semibold user-border mb-0">
              User’s Details
            </p>
          </div>
          <div>
            <div className="user-detail-search-form">
              <Row className="g-3">
                <Col md>
                  <FormLabel controlId="floatingInputGrid">
                    <Form.Control
                      name="full_name"
                      onChange={handleChange}
                      value={state.full_name}
                      type="text"
                      placeholder="Enter Full Name"
                    />
                  </FormLabel>
                  {state.errors && (
                    <span className="text-danger">
                      {state.errors.full_name}
                    </span>
                  )}
                </Col>
                <Col md>
                  <FormLabel
                    controlId="floatingInputGrid"
                    // label="Email address"
                  >
                    <Form.Control
                      type="text"
                      name="email"
                      onChange={handleChange}
                      value={state.email}
                      placeholder="Enter Email Address"
                    />
                  </FormLabel>
                  {state.errors && (
                    <span className="text-danger">{state.errors.email}</span>
                  )}
                </Col>
                <Col md>
                  {/* <FormLabel
                  controlId="floatingInputGrid"
                  // label="Phone number"
                > */}
                  {/* <Form.Control
                    type="text"
                    name="phone"
                    onChange={handleChange}
                    value={state.phone}
                    placeholder="Enter phone number"
                  /> */}
                  {(state.phone === "" || state.phone === "1") && (
                    <label
                      onClick={() => {
                        console.log(
                          "phoneref",
                          phoneRef.current.numberInputRef.focus()
                        );
                      }}
                      className="phone-lable"
                    >
                      (324) 242-3423
                    </label>
                  )}
                  <PhoneInput
                    country={"us"}
                    preferredCountries={["us", "ca"]}
                    inputClass="form-contorl"
                    countryCodeEditable={state.isCountryEditable}
                    onChange={(d) => handlePhoneChange(d)}
                    placeholder="+1 (324) 242-3423"
                    onFocus={() =>
                      setState({ ...state, isCountryEditable: false })
                    }
                    // disableCountryCode
                    value={state.phone}
                    ref={phoneRef}
                  />
                  {state.errors && (
                    <span className="text-danger">{state.errors.phone}</span>
                  )}
                </Col>
              </Row>
              <Row>
                <TermsAndAckowledgeCheckbox
                  handleCheckbox={(e) => {
                    setState({
                      ...state,
                      isTermsAccepted: e.target.checked,
                      errors: { ...state.errors, isTermsAccepted: null },
                    });
                  }}
                  isTermsAccepted={state?.isTermsAccepted}
                  errors={state.errors}
                />
              </Row>
            </div>
            <div className="search-button position-relative text-center">
              {mainType !== EVISA_INQ_TYPE && (
                <button
                  // onClick={() =>
                  //   // navigate(appRoutesConst.searchflight)
                  // }
                  onClick={submitFlightSearch}
                  className="btn btn-primary"
                >
                  {state.submitting ? (
                    <span>
                      <span>Searching Flights ...</span>{" "}
                    </span>
                  ) : (
                    "Search"
                  )}
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
